import { Box, Divider, Grid } from '@mui/material'
import ProfileSectionHeader from 'components/common/ProfileSectionHeader/ProfileSectionHeader';
import useGlobalStyles from 'styles/globalStyles'
import { colors } from 'styles/colors';
import { useProfileContext } from 'context/ProfileContext';
import PositionItemSkeleton from '../PositionItemSkeleton/PositionItemSkeleton';
import SchoolIcon from "@mui/icons-material/School";
import AddEducationButton from '../AddEducationButton/AddEducationButton';
import EducationItem from '../EducationItem/EducationItem';
import { hexWithOpacity } from 'common/utils';
import CustomText from 'components/common/CustomText/CustomText';

export default function Educations() {
  const globalStyles = useGlobalStyles();
  const { educations, isLoading } = useProfileContext();
  const showSkeleton = isLoading && educations.length === 0;

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Education'}
          icon={<SchoolIcon sx={{ fontSize: 20, color: colors.primary }} />}
          buttons={[
            <AddEducationButton key='education' />
          ]}
        />
      </Box>

      <Divider />

      <Grid
        container
        spacing={1.5}
        p={2}
        sx={{
          flexGrow: showSkeleton || educations.length > 0 ? 0 : 1,
          display: 'flex',
        }}
      >
        {showSkeleton ? (
          Array.from({ length: 12 }).map((_, index) => (
            <Grid
              key={index}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <PositionItemSkeleton />
            </Grid>
          ))
        ) : educations?.length === 0 ? (
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              textAlign="center"
              gap={2}
            >
              <Box height={100}>
                <SchoolIcon
                  sx={{ fontSize: 100, color: hexWithOpacity(colors.secondary, 0.5) }}
                />
              </Box>
              <CustomText
                text='No education added yet'
                color={colors.secondary}
              />
            </Box>
          </Grid>
        ) : (
          educations.map((item: any) => (
            <Grid
              key={item.id}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <EducationItem item={item} />
            </Grid>
          ))
        )}
      </Grid>

    </Box>
  )
}
